/**
 *Angular module*/
import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, ResolveEnd, ResolveStart, RouteConfigLoadEnd, RouteConfigLoadStart, Router, RouterEvent, UrlSegment} from '@angular/router';
import {FormControl} from '@angular/forms';
/**
 *Shared*/
import {SharedAnimations} from 'src/app/shared/animations/shared-animations';
import {NavigationService} from '../../../services/navigation.service';
import {SearchService} from 'src/app/shared/services/search.service';
import {ErrorAlertService} from '../../../services/error-alert.service';
import {SessionStorageService} from '../../../services/session-storage.service';
import {ParentChildService} from '../../../services/parent-child.service';
/**
 *RxJS*/
import {Subscription} from 'rxjs/Subscription';
/**
 *NGX*/
import {TranslateService} from '@ngx-translate/core';
import {PerfectScrollbarDirective} from 'ngx-perfect-scrollbar';
/**
 *Global*/
import {DEVELOPER_MODE, NAMED_OUTLETS, routerOutlet} from '../../../../global';

/**
 *Interfaces*/
interface Alert {
    type: string;
    message: string;
}

/**
 *Constants*/
const ALERTS: Alert = {
    type: 'danger',
    message: '',
};

@Component({
    selector: 'app-dashboard-tab',
    template: '<router-outlet></router-outlet>'
})
export class DashboardTabComponent {
    constructor() {
    }
}

@Component({
    selector: 'app-product-configuration-tab',
    template: '<router-outlet name="product-configuration"></router-outlet>'
})
export class ProductConfigurationTabComponent {

    constructor() {
    }
}

@Component({
    selector: 'app-hrms-tab',
    template: '<router-outlet name="hrms"></router-outlet>'
})
export class HRMSTabComponent {

    constructor() {
    }
}

@Component({
    selector: 'app-vending-machine-tab',
    template: '<router-outlet name="vending-machine"></router-outlet>'
})
export class VendingMachineTabComponent {

    constructor() {
    }
}

@Component({
    selector: 'app-customer-tab',
    template: '<router-outlet name="customer"></router-outlet>'
})
export class CustomerTabComponent {

    constructor() {
    }
}

@Component({
    selector: 'app-authority-management-tab',
    template: '<router-outlet name="authority-management"></router-outlet>'
})
export class AuthorityManagementComponent {

    constructor() {
    }
}

@Component({
    selector: 'app-account-management-tab',
    template: '<router-outlet name="account-management"></router-outlet>'
})
export class AccountManagementComponent {

    constructor() {
    }
}

@Component({
    selector: 'app-agency-tab',
    template: '<router-outlet name="agency"></router-outlet>'
})
export class AgencyComponent {

    constructor() {
    }
}

@Component({
    selector: 'app-report-tab',
    template: '<router-outlet name="report"></router-outlet>'
})
export class ReportTabComponent {

    constructor() {
    }
}

@Component({
    selector: 'app-admin-layout',
    templateUrl: './admin-layout.component.html',
    styleUrls: ['./admin-layout.component.scss'],
    animations: [SharedAnimations]
})
export class AdminLayoutComponent implements OnInit, OnDestroy {
    moduleLoading: boolean;
    alertCards: Alert;
    showAlert = false;
    subscription: Subscription;
    isDeveloper = DEVELOPER_MODE;
    isDashboard = true;
    @ViewChild(PerfectScrollbarDirective) perfectScrollbar: PerfectScrollbarDirective;

    public tabs = [
        {
            label: 'Dashboard Tab',
            component: DashboardTabComponent,
        },
        {
            label: 'Product Configuration Tab',
            component: ProductConfigurationTabComponent,
        },
        {
            label: 'HRMS Tab',
            component: HRMSTabComponent,
        },
        {
            label: 'Vending Machine Tab',
            component: VendingMachineTabComponent,
        },
        {
            label: 'Customer Tab',
            component: CustomerTabComponent,
        },
        {
            label: 'Authority Management Tab',
            component: AuthorityManagementComponent,
        },
        {
            label: 'Account Management Tab',
            component: AccountManagementComponent,
        },
        {
            label: 'Agency Tab',
            component: AgencyComponent,
        },
        {
            label: 'Report Tab',
            component: ReportTabComponent,
        }
    ];
    isTabView = NAMED_OUTLETS;
    public dynamicTabs: any;
    selected = new FormControl(0);

    constructor(public navService: NavigationService,
                public sessionStorageService: SessionStorageService,
                public searchService: SearchService,
                public translate: TranslateService,
                public errorAlertService: ErrorAlertService,
                public parentChildService: ParentChildService,
                private activatedRoute: ActivatedRoute,
                private router: Router) {
        this.dynamicTabs = [
            {
                label: 'Dashboard Tab',
                initialRoute: '/',
                outlets: {
                    outlets: {
                        [routerOutlet['dashboard']]: ['dashboard']
                    }
                }
            },
            {
                label: 'Product Configuration Tab',
                initialRoute: '/product-configuration',
                outlets: {
                    outlets: {
                        [routerOutlet['product-configuration']]: ['category']
                    }
                }
            },
            {
                label: 'HRMS Tab',
                initialRoute: '/hrms',
                outlets: {
                    outlets: {
                        [routerOutlet['hrms']]: ['department']
                    }
                }
            },
            {
                label: 'Vending Machine Tab',
                initialRoute: '/vending-machine',
                outlets: {
                    outlets: {
                        [routerOutlet['vending-machine']]: ['vending-machine']
                    }
                }
            },
            {
                label: 'Customer Tab',
                initialRoute: '/customer',
                outlets: {
                    outlets: {
                        [routerOutlet['customer']]: ['customer']
                    }
                }
            },
            {
                label: 'Authority Management Tab',
                initialRoute: '/authority-management',
                outlets: {
                    outlets: {
                        [routerOutlet['authority-management']]: ['user-role']
                    }
                }
            },
            {
                label: 'Account Management Tab',
                initialRoute: '/account-management',
                outlets: {
                    outlets: {
                        [routerOutlet['account-management']]: ['agent']
                    }
                }
            },
            {
                label: 'Agency Tab',
                initialRoute: '/agency',
                outlets: {
                    outlets: {
                        [routerOutlet['agency']]: ['branch']
                    }
                }
            },
            {
                label: 'Report Tab',
                initialRoute: '/report',
                outlets: {
                    outlets: {
                        [routerOutlet['report']]: ['branch']
                    }
                }
            }
        ];
    }

    ngOnInit() {
        this.subscription = this.errorAlertService.on('error-alert')
            .subscribe(() => {
                this.translate.get(this.errorAlertService.getError()).subscribe((response: string) => ALERTS.message = response);
                this.alertCards = ALERTS;
                this.showAlert = true;
            });
        this.subscription = this.parentChildService.on('route-change')
            .subscribe(() => {
                this.isDashboard = window.location.hash.search('dashboard') > -1 || window.location.hash.search('personal-profile') > -1;
                const sessionOutlet = this.dynamicTabs[this.navService.getActiveTabIndex()]['outlets']['outlets'];
                const activeRoute = <ActivatedRoute>this.activatedRoute.children[0]['children'][0];
                activeRoute.url.subscribe((params: Array<UrlSegment>) => {
                    if (activeRoute.outlet == Object.keys(sessionOutlet)[0]) {
                        this.dynamicTabs[this.navService.getActiveTabIndex()]['outlets']['outlets'][Object.keys(sessionOutlet)[0]][0] = params.toString();
                    }
                });
                this.selected.setValue(this.navService.getActiveTabIndex());
            });
        this.router.events.subscribe((event: RouterEvent | any) => {
            if (event instanceof RouteConfigLoadStart || event instanceof ResolveStart) {
                this.moduleLoading = true;
            }
            if (event instanceof RouteConfigLoadEnd || event instanceof ResolveEnd) {
                this.moduleLoading = false;
            }
        });
        const outlet = this.activatedRoute.children[0]['children'][0]['outlet'];
        this.selected.setValue(this.dynamicTabs.findIndex((tab: any) => Object.keys(tab.outlets.outlets)[0] == outlet));
    }

    setActiveTab(index: number, check: boolean = false): void {
        if (check) {
            this.router.navigate([this.dynamicTabs[index]['initialRoute'], this.dynamicTabs[index]['outlets']]);
        }
        this.selected.setValue(index);
    }

    closeAlertCard() {
        this.showAlert = false;
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

}
